// extracted by mini-css-extract-plugin
module.exports = {"gw_reviewInfo_para":"SummaryPage_gw_reviewInfo_para__yfwGV","gwReviewInfoPara":"SummaryPage_gw_reviewInfo_para__yfwGV","tncAcceptance":"SummaryPage_tncAcceptance__1cmkb"};